import React from "react";

interface DashboardListItemProps {
  href: string;
  title: string;
  leftContent?: React.ReactNode;
  rightLabel: string;
}

const DashboardListItem: React.FC<DashboardListItemProps> = ({
  href,
  title,
  leftContent,
  rightLabel,
}) => (
  <li className="mb-2 group relative">
    <a
      href={href}
      className="font-medium block w-full transition-colors hover:text-primary"
    >
      <span
        className="truncate max-w-[200px] inline-block align-middle"
        title={title}
      >
        {leftContent} {title}
      </span>
      <span className="absolute right-0 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity text-primary text-sm flex items-center gap-1 bg-base-100 pl-4">
        {rightLabel} <span aria-hidden>→</span>
      </span>
    </a>
  </li>
);

export default DashboardListItem;